//@flow
/* global window: true */
import * as defaultBus from './messageBus';

// Exported functions
export const {
    publish,
    subscribe,
    publishSticky,
    unsubscribe,
} = (function messageBus(root: Object) {
    return root.WH && root.WH.messageBus ? root.WH.messageBus : defaultBus;
}(typeof window !== 'undefined' ? window : global));

export * from './types';
